module.exports = __webpack_public_path__ + "img/1.1fc58597.png";